import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { gridGapStyles, scalableIconStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export interface StoreAttibutesProps {
    container?: GridContainerProps;
    item?: GridItemProps;
    label?: TypographyPresentationProps;
    value?: TypographyPresentationProps;
    message?: TypographyPresentationProps;
}

export const attributesProps: StoreAttibutesProps = {
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles([], [".5em"])}
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: ${TYPOGRAPHY.lineHeight.small};
        `,
    },
    item: {
        width: 12,
        css: css`
            flex-flow: wrap;
        `,
    },
    label: {
        size: TYPOGRAPHY.size.base,
        color: "text.accent",
        css: css`
            margin-right: 0.3em;
        `,
    },
    value: {
        color: "text",
        weight: TYPOGRAPHY.weight.bold,
        size: TYPOGRAPHY.size.base,
        css: css`
            word-break: break-all;
        `,
    },
    message: {
        color: "text.accent",
        italic: true,
        size: TYPOGRAPHY.size.smallest,
        weight: TYPOGRAPHY.weight.bold,
        lineHeight: TYPOGRAPHY.lineHeight.small,
        css: css`
            margin-top: 0.5em;
            display: inline-block;
            flex-basis: 100%;
        `,
    },
};
